export const isActive = (
  insidePaths: string[] | undefined,
  pathname: string
) => {
  return insidePaths?.some((path: string) => pathname.includes(path));
};
